import { useTranslation } from 'react-i18next';

import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

export interface SkuOriginChipProps {
  /** Where the value came from: the rule, or someone's keyboard. */
  origin: 'generated' | 'manual';
  className?: string;
}

/** A small "generated" or "manual" chip next to a style number or variant SKU. */
export function SkuOriginChip({ origin, className }: SkuOriginChipProps) {
  const { t } = useTranslation('products');
  return (
    <Badge
      variant={origin === 'manual' ? 'secondary' : 'outline'}
      data-testid={`sku-origin-${origin}`}
      className={cn('text-muted-foreground px-1.5 py-0 text-[11px] font-normal', className)}
    >
      {t(`sku.${origin}`)}
    </Badge>
  );
}
